var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 612,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130.001,
    cy: 264.079,
    r: 347.329,
    stroke: "#B8BEF3",
    strokeWidth: 0.5,
    strokeDasharray: "14 14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse1);
export default __webpack_public_path__ + "static/media/Ellipse-1.b54592d0720aff62b96eb975edcd8da8.svg";
export { ForwardRef as ReactComponent };